








































import {
    computed,
    defineComponent,
    ref,
    watchEffect,
} from '@vue/composition-api';

export default defineComponent({
    name: 'pure-input-text',
    props: {
        type: {
            type: String,
            default: 'text',
        },
        width: {
            type: String,
            default: '280',
        },
        height: {
            type: String,
            default: '28',
        },
        maxLen: {
            type: Number,
            default: 524288,
        },
        minLen: {
            type: Number,
            default: 1,
        },
        placeholder: String,
        value: String,
        showWordLimit: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
        },
        statusIcon: {
            type: Boolean,
            default: true,
        },
    } as any,
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        const inputVal = computed({
            get: () => {
                return props.value;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });
        const inputRef = ref<any>();
        watchEffect(() => {
            const input: HTMLElement | undefined = inputRef.value?.getInput();
            if (input) {
                if (props.status === 'error') {
                    input.classList.add('input-text-error');
                } else {
                    input.classList.remove('input-text-error');
                }
            }
        });

        return {
            inputVal,
            inputRef,
        };
    },
});
